import { generateContentIdeas as openaiGenerateIdeas } from '../services/openai';
import type { ContentIdea } from '../stores/ideaStore';
import type { Platform } from '../stores/socialMediaStore';

export const generateAIIdeas = async (
  platforms: Platform[],
  count: number = 3
): Promise<ContentIdea[]> => {
  try {
    // Get ideas from OpenAI
    const ideas = await openaiGenerateIdeas();
    
    // Ensure we have at least one platform
    const availablePlatforms = platforms.length > 0 ? platforms : ['instagram'];
    
    // Assign platforms to ideas based on connected accounts
    return ideas.map((idea, index) => ({
      ...idea,
      category: availablePlatforms[index % availablePlatforms.length]
    })).slice(0, count);
  } catch (error) {
    console.error('Error in generateAIIdeas:', error);
    // Re-throw to allow the UI layer to handle the error
    throw new Error('Falha ao gerar ideias. Por favor, tente novamente.');
  }
};